<template>
    <div id="orgRegisterThree">
        <OrgRegisterStepFour class="register-container" />
    </div>
</template>
<script>
import OrgRegisterStepFour from '@/components/org/register/OrgRegisterStepFour';
export default {
  components: {
    OrgRegisterStepFour
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$root.layout.isLoading = false;
    }
  }
};
</script>
<style lang="less" scoped>
#orgRegisterThree {
  width: 100%;
  .register-container {
    height: 822px;
    width: 100%;
    background: #cbcaca;
  }
}
</style>
